import React, { useEffect } from 'react';
import { initPixel } from './lib/metaPixel';
import { StickyBars } from './components/StickyBars';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Protocolo 7 Días Sin Reinfestación | Wise Lice Control';
    initPixel();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-slate-900 pb-24 sm:pb-0" data-id="element-0">
      <StickyBars data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Hook data-id="element-4" />
        <Problem data-id="element-5" />
        <Mechanism data-id="element-6" />
        <Deliverables data-id="element-7" />
        <TargetAudience data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Offer data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}